import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useSession } from '@cordata/buffet';
import { Accordian, PageLayout } from '~/components';
import usePatient from '~/utils/patient/hook';
import { IdentityPageProvider } from '~/utils/identity/page';
import { hasFullPatientIdentityAccess, hasLegalStatus } from '~/utils/patient/identity-access';

import UpcomingAppointments from './upcoming-appointments';
import OpenReferrals from './open-referrals';
import MissedAppointments from './missed-appointments';
import Scheduling from './scheduling';

const ReferralsAndAppointments = () => {
  const [, patient, actions] = usePatient();
  const { current } = useSession();

  const pageSpec = {
    title: 'Referrals & Appointments',
    enableFullPrint: false,
    enableIndividualPrint: hasLegalStatus(patient),
    panels: [{
      title: 'Upcoming Appointments',
      body: <UpcomingAppointments />,
    }, {
      title: 'Open Referrals',
      body: <OpenReferrals />,
    }, {
      title: 'Missed Appointments',
      body: <MissedAppointments />,
    }, {
      title: 'Scheduling',
      body: <Scheduling />,
    }],
  };

  useEffect(() => {
    actions.audit('ReferralAppt');
  }, []);

  if (!hasFullPatientIdentityAccess(patient, current?.attributes?.accessibleDivisions)) {
    return <Redirect to={`/patients/${patient.id}`} />;
  }

  return (
    <PageLayout>
      <IdentityPageProvider pageSpec={pageSpec}>
        {({
          accordianItems,
          allPanelsOpen,
          expandPanel,
          openPanel,
        }) => (
          <Accordian
            openPanel={openPanel}
            allOpen={allPanelsOpen}
            initialOpen={0}
            items={accordianItems}
            setOpenPanel={expandPanel}
          />
        )}
      </IdentityPageProvider>
    </PageLayout>
  );
};

export default ReferralsAndAppointments;
